import { render } from "./AbsenceRegistrationDetailComponent.vue?vue&type=template&id=18feb7bc&scoped=true"
import script from "./AbsenceRegistrationDetailComponent.vue?vue&type=script&lang=js"
export * from "./AbsenceRegistrationDetailComponent.vue?vue&type=script&lang=js"

import "./AbsenceRegistrationDetailComponent.vue?vue&type=style&index=0&id=18feb7bc&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18feb7bc"]])

export default __exports__